import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-6 pt-24 pb-16">
      <Seo
        title="Pagina non trovata | Laure Hila — Viaggia in Grande"
        description="La pagina che cerchi non esiste o è stata spostata."
        robots="noindex, follow"
      />
      <div className="text-center">
        <p className="eyebrow mb-4">Errore 404</p>
        <h1 className="font-serif text-4xl md:text-6xl text-ink tracking-tight">
          Questa strada non porta <span className="italic text-gold">da nessuna parte</span>.
        </h1>
        <p className="mt-5 text-stone text-base md:text-lg">
          La pagina che cerchi non esiste o è stata spostata.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-8 inline-flex items-center justify-center px-8 py-4 rounded-full bg-ink text-cream font-semibold text-sm tracking-wide hover:bg-gold transition-colors duration-300"
        >
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
